import React from 'react'

import {
  MarkdownTextFullPageContainer,
  MarkdownTextFullPageHeadingContainer,
  MarkdownTextFullPageFlexContainer,
  MarkdownTextFullPageInnerFlexContainer,
} from './index.module.css'

const MarkdownTextFullPage = ({ title, subtitle, hideTitle }) => {
  return (
    <div className="wrapper">
      <div className={MarkdownTextFullPageContainer}>
        {!hideTitle && (
          <div className={MarkdownTextFullPageHeadingContainer}>
            <h2>{title}</h2>
          </div>
        )}

        <div className={MarkdownTextFullPageFlexContainer}>
          <div className={MarkdownTextFullPageInnerFlexContainer}>
            <div
              dangerouslySetInnerHTML={{
                __html: subtitle.childMarkdownRemark.html,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default MarkdownTextFullPage
